/**
 * 404 — page-not-found.
 *
 * Centered message + link to root. Phase 1 doesn't bother branching the
 * layout based on auth state — the layout is whatever the matching parent
 * route already mounted (RootLayout when nested under RequireAuth, the
 * AuthLayout when not).
 *
 * Live-VPS UI review (2026-05-08, defect #5): the page rendered a bare
 * `<section>` outside any `<main>` landmark — assistive tech could not
 * find the main region. The fix wraps the content in `<main>` so SR
 * users get the same landmark treatment as the rest of the app. The
 * inner `<section>` keeps its testid and aria-labelledby so existing
 * selectors / spec assertions are untouched.
 */
import * as React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): React.ReactElement {
  return (
    <main className="flex-1">
      <section
        data-testid="not-found"
        aria-labelledby="not-found-title"
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 py-16 text-center"
      >
        <span aria-hidden className="text-5xl font-semibold text-muted">
          404
        </span>
        <h1 id="not-found-title" className="text-xl font-semibold text-ink">
          Страница не найдена
        </h1>
        <p className="text-sm text-muted-foreground">
          Возможно, ссылка устарела или адрес введён с ошибкой.
        </p>
        <Link to="/" className="text-sm text-accent underline-offset-4 hover:underline">
          На главную
        </Link>
      </section>
    </main>
  );
}
